import { IssueReport } from "../../../../globals/interfaces";
import VirtualTable from "../../../custom/VirtualTable";

export default function DataTable({
    data,
    viewIssue
}: {
    data: Array<IssueReport>;
    viewIssue: (id: number) => void;
}) {
    return (
        <VirtualTable<IssueReport>
            data={data}
            mapping={[{
                name: 'Ticket',
                value: 'id',
                number: true,
                customWidth: 50
            }, {
                name: 'Status',
                value: 'status',
                customWidth: 150
            }, {
                name: 'Ownership',
                value: 'assignedTo',
                email: true
            }, {
                name: 'Submitted at',
                value: 'createdAt',
                datetime: true,
                utc: true
            }, {
                name: 'Submitted by',
                value: 'createdBy',
                email: true
            }, {
                name: 'Unit',
                value: 'unit',
                customWidth: 100
            }, {
                name: 'Details',
                value: 'details'
            }]}
            handleClick={item => viewIssue(item.id)}
        />

    );
}